module.exports = __webpack_public_path__ + "static/media/poop.a420d01c.svg";